/* PAGE: HOME
   ========================================================================== */

import { ReactNode, useEffect, useMemo, useState } from 'react';
import { Trans } from 'react-i18next';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import {
  Avatar,
  Box,
  Button,
  Center,
  chakra,
  Container,
  Divider,
  Flex,
  Heading,
  Image,
  Link,
  SimpleGrid,
  Stack,
  Text,
  useColorMode,
  useColorModeValue,
  VisuallyHidden,
} from '@chakra-ui/react';
import { useMediaQuery } from '@material-ui/core';
import { message } from 'antd';
import { dispatch, useSelector } from 'common';
import { DISCORD_LINK } from 'config/social-links';
import { ApiConstants, NetWorkService } from 'library/networking';
import { $t } from 'library/utils';
import { FaDiscord, FaGithub, FaTelegram, FaTwitter } from 'react-icons/fa';
import { appActions, homeActions } from 'redux/action-slice';
import ROUTES from 'routes/constant';
import './index.scss';

import Styled from './index.style';

import { ConnectWallet } from '../../containers/layouts/navbar/connect-wallet';
// import { getUrlFromSVGText } from './svg/function';

const SocialButton = ({
  children,
  label,
  href,
}: {
  children: ReactNode;
  label: string;
  href: string;
}) => {
  return (
    <chakra.button
      // bg={useColorModeValue('blackAlpha.100', 'whiteAlpha.100')}
      rounded={'full'}
      w={8}
      h={8}
      cursor={'pointer'}
      as={'a'}
      href={href}
      display={'inline-flex'}
      alignItems={'center'}
      justifyContent={'center'}
      transition={'background 0.3s ease'}
      _hover={
        {
          // bg: useColorModeValue('blackAlpha.200', 'whiteAlpha.200'),
        }
      }>
      <VisuallyHidden>{label}</VisuallyHidden>
      {children}
    </chakra.button>
  );
};

const Home = () => {
  //state
  const [searchParams] = useSearchParams('code');
  const navigate = useNavigate();
  const { colorMode } = useColorMode();
  const { pathname } = useLocation();
  const { userInfo } = useSelector(state => state.app);
  const [isWhitelist, setIsWhitelist] = useState(true);
  const bgButton = useColorModeValue(
    'linear-gradient(90deg, #7E4698 0%, #529DD0 100%)',
    'linear-gradient(90deg, #7E4698 0%, #529DD0 100%)',
  );
  const colorButton = 'white';
  const bg = useColorModeValue('bg-white', 'bg-antd');
  const textColor = useColorModeValue('text-black', 'text-white');

  const code = useMemo(() => searchParams.get('code'), [searchParams]);

  useEffect(() => {
    if (pathname.includes(ROUTES.linkTelegram) && code) {
      verifyTelegramOTP(code);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, code]);

  useEffect(() => {
    if (userInfo?.wallet_address) {
      navigate(ROUTES.messages, { replace: true });
    }
  }, []);

  useEffect(() => {
    const checkPermission = async () => {
      if (userInfo?.wallet_address) {
        //WhiteList
        // const permissionResponse = await NetWorkService.Get<WHITELIST_PERMISSION>({
        //   url: ApiConstants.CHECK_WHITELIST,
        //   params: {
        //     address: userInfo.wallet_address,
        //   },
        // });

        dispatch(appActions.setIsWhitelist(true));
        // if (permissionResponse?.data) {
        //   const { is_exist } = permissionResponse.data;
        //   setIsWhitelist(is_exist);
        //   dispatch(appActions.setIsWhitelist(is_exist));
        // }
      } else {
        setIsWhitelist(false);
        dispatch(appActions.setIsWhitelist(false));
      }
    };

    checkPermission();
  }, [userInfo?.wallet_address]);

  const renderButton = useMemo(() => {
    const clickHandler = () => {
      launchApp();
      // if (isWhitelist) {
      //   launchApp();
      // } else {
      //   handleNavigate();
      // }
    };
    // const labelText = isWhitelist ? 'Launch App' : 'Pre-Registration';
    const labelText = 'Launch App';
    return (
      // <Button
      //   onClick={clickHandler}
      //   rounded={'full'}
      //   _hover={{ boxShadow: 'none', opacity: 0.75 }}
      //   bg={bgButton}
      //   color={colorButton}
      //   fontSize="lg"
      //   borderRadius="14px"
      //   px="30px"
      //   display={{
      //     sm: 'none',
      //     lg: 'flex',
      //   }}>
      //   {labelText}
      // </Button>
      <ConnectWallet is_watch_address={false}></ConnectWallet>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isWhitelist, bgButton]);

  const verifyTelegramOTP = async (otp: string) => {
    const response = await NetWorkService.Post<boolean>({
      url: ApiConstants.VERIFY_TELEGRAM_OTP,
      body: {
        otp,
      },
    });

    if (response?.data) {
      message.success('Link Telegram successfully');
      dispatch(
        homeActions.onGetUserInfo(data => {
          dispatch(appActions.onSetUserInfo(data));
        }),
      );
    } else {
      message.error((response?.message as string) || 'Unauthorized');
    }

    navigate(ROUTES.messages, { replace: true });
  };

  const handleNavigate = () => {
    const campaign = searchParams.get('campaign');
    navigate(campaign ? `${ROUTES.preRegistration}?campaign=${campaign}` : ROUTES.preRegistration);
  };

  const launchApp = () => {
    navigate(ROUTES.messages);
  };

  const isSmallScreen = useMediaQuery('(max-width: 768px)');

  //render
  return (
    <Styled.Container
      style={{ width: '100%', justifyContent: 'start' }}
      className={`${bg} relative`}>
      <Box
        backgroundImage="url('/images/grblue.jpg')"
        backgroundPosition="center"
        backgroundRepeat="no-repeat">
        <Container maxW={'8xl'}>
          <Stack
            as={Box}
            textAlign={'center'}
            spacing={{ base: 8, md: 14 }}
            py={{ base: 20, md: 36 }}>
            <Heading
              fontWeight={'bold'}
              fontSize={{ base: '4xl', md: '5xl', xl: '6xl' }}
              lineHeight={'110%'}>
              Web3 Communication <br />
              <Text as={'span'} color={'#7E4698'}>
                Protocol
              </Text>
            </Heading>
            <Text color={'gray.500'}>
              <span
                dangerouslySetInnerHTML={{
                  __html: $t('home:welcome_dmtp'),
                }}></span>

              {/* DMTP is a protocol that allows users to exchange
              <br /> messages based on their wallet addresses. <br />
              Users can send and receive messages to each other, and Dapps can
              <br /> send notifications and messages to the users. */}
            </Text>
            <Stack
              direction={'column'}
              spacing={3}
              align={'center'}
              alignSelf={'center'}
              position={'relative'}>
              {renderButton}
              <Link
                color={'blue.400'}
                colorScheme={'blue'}
                isExternal
                rel="noopener,noreferrer"
                href="https://dmtp.gitbook.io/dmtp-docs">
                {$t('home:document')}
              </Link>
            </Stack>
          </Stack>
        </Container>
      </Box>
      {/* </div> */}
      <div className={'section-common'}>
        <Flex justifyContent={'center'} alignItems={'center'} mb={10}>
          <Box w={'70%'}>
            <Stack
              as={Box}
              textAlign={'center'}
              spacing={{ base: 0, md: 0 }}
              py={{ base: 0, md: 0 }}
              p={'auto'}
              mb={50}>
              <Heading
                pt={20}
                fontWeight={600}
                fontSize={{ base: '5xl', md: '6xl', xl: '7xl' }}
                lineHeight={'110%'}
                className={`${textColor}`}>
                {$t('home:features')}
              </Heading>
            </Stack>
            <Stack minH={'10vh'} direction={{ base: 'column', md: 'row' }} className="sm:">
              <Center flex={1}>
                {isSmallScreen ? (
                  <Image
                    mt={'auto'}
                    alt={'Login Image'}
                    src={'images/multichain.svg'}
                    width="334px"
                    height="240px"
                  />
                ) : (
                  <Center>
                    <Image
                      alt={'Login Image'}
                      src={'images/multichain.svg'}
                      width={{ base: '282px', md: '230px', lg: '334px' }}
                      height={{ base: '202px', md: '165px', lg: '240px' }}
                    />
                  </Center>
                )}
              </Center>
              <Center p={{ base: 2, md: 8 }} flex={1}>
                <Stack spacing={6} w={'full'} maxW={'lg'}>
                  {isSmallScreen ? (
                    <Heading
                      fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}
                      textAlign={{ base: 'center', md: 'left' }}>
                      <Text position={'relative'}>
                        Support <span color={'#7E4698'}>All Chains</span>
                      </Text>{' '}
                    </Heading>
                  ) : (
                    <Heading
                      fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}
                      textAlign={{ base: 'center', md: 'left' }}>
                      <Text
                        as={'span'}
                        position={'relative'}
                        className={`${colorMode === 'dark' ? 'text-white' : 'text-black'}`}>
                        Support
                      </Text>
                      <br />{' '}
                      <Text color={'#7E4698'} as={'span'}>
                        All Chains
                      </Text>{' '}
                    </Heading>
                  )}
                  <Text
                    fontSize={{ base: 'md', lg: 'lg' }}
                    color={'gray.500'}
                    textAlign={{ base: 'center', md: 'left' }}>
                    {$t('home:all_chains_description')}
                  </Text>
                  <Stack direction={{ base: 'column', md: 'row' }} spacing={4}>
                    <Center>
                      <Link
                        href="https://dmtp.gitbook.io/dmtp-docs/dmtp-system/supported-chain"
                        isExternal>
                        <Button
                          rounded={'full'}
                          _hover={{ boxShadow: 'none', opacity: 0.75 }}
                          bg={bgButton}
                          color={colorButton}
                          fontSize="sm"
                          borderRadius="14px"
                          px="30px"
                          display={'flex'}>
                          {$t('home:learn_more')}
                        </Button>
                      </Link>
                    </Center>
                  </Stack>
                </Stack>
              </Center>
            </Stack>

            <Divider m={10} />

            <Stack minH={'10vh'} direction={{ base: 'column', md: 'row' }} p={'auto'}>
              <Center flex={1}>
                {isSmallScreen ? (
                  <Image
                    alt={'Login Image'}
                    objectFit={'cover'}
                    src={'images/incentives.svg'}
                    width="282px"
                    height="238px"
                  />
                ) : (
                  <Center pt={{ base: 0, xl: 100 }}>
                    <Image
                      alt={'Login Image'}
                      objectFit={'cover'}
                      src={'images/incentives.svg'}
                      width={{ base: '282px', md: '230px', lg: '334px' }}
                      height={{ base: '238px', md: '194px', lg: '282px' }}
                    />
                  </Center>
                )}
              </Center>
              <Center p={{ base: 2, md: 8 }} flex={1}>
                <Stack spacing={6} w={'full'} maxW={'lg'}>
                  <Heading
                    fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}
                    textAlign={{ base: 'center', md: 'left' }}>
                    <Text as={'span'} position={'relative'} className={`${textColor}`}>
                      Rewards For
                    </Text>
                    <br />{' '}
                    <Text color={'#7E4698'} as={'span'}>
                      User and Dapps
                    </Text>{' '}
                  </Heading>
                  <Text
                    fontSize={{ base: 'md', lg: 'lg' }}
                    color={'gray.500'}
                    textAlign={{ base: 'center', md: 'left' }}>
                    {$t('home:rewards_description')}
                  </Text>
                  <Stack direction={{ base: 'column', md: 'row' }} spacing={4}>
                    <Center>
                      <Link
                        href="https://dmtp.gitbook.io/dmtp-docs/about-dmtp/rewards-for-users-and-dapps"
                        isExternal>
                        <Button
                          rounded={'full'}
                          _hover={{ boxShadow: 'none', opacity: 0.75 }}
                          bg={bgButton}
                          color={colorButton}
                          fontSize="sm"
                          borderRadius="14px"
                          px="30px"
                          display={'flex'}>
                          {$t('home:learn_more')}
                        </Button>
                      </Link>
                    </Center>
                  </Stack>
                </Stack>
              </Center>
            </Stack>

            <Divider m={10} />

            {/* <Stack minH={'10vh'} direction={{ base: 'column', md: 'row' }} p={'auto'}>
              <Center flex={1}>
                {isSmallScreen ? (
                  <Image
                    alt={'Login Image'}
                    objectFit={'cover'}
                    src={'images/sticker.svg'}
                    width="240px"
                    height={'240px'}
                  />
                ) : (
                  <Center>
                    <Image
                      alt={'Login Image'}
                      objectFit={'cover'}
                      src={'images/sticker.svg'}
                      width={{ base: '282px', md: '230px', lg: '334px' }}
                      height={{ base: '282px', md: '230px', lg: '334px' }}
                    />
                  </Center>
                )}
              </Center>
              <Center p={{ base: 2, md: 8 }} flex={1}>
                <Stack spacing={6} w={'full'} maxW={'lg'}>
                  <Heading
                    fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}
                    textAlign={{ base: 'center', md: 'left' }}>
                    <Text
                      as={'span'}
                      position={'relative'}
                      textAlign={{ base: 'center', md: 'left' }}
                      className={`${textColor}`}>
                      Chat Sticker
                    </Text>
                    <Text
                      position={'relative'}
                      textAlign={{ base: 'center', md: 'left' }}
                      color={'#7E4698'}
                      as={'span'}>
                      NFT
                    </Text>
                  </Heading>
                  <Text
                    fontSize={{ base: 'md', lg: 'lg' }}
                    color={'gray.500'}
                    textAlign={{ base: 'center', md: 'left' }}>
                    {$t('home:chat_nft_description')}
                  </Text>
                  <Stack direction={{ base: 'column', md: 'row' }} spacing={4}>
                    <Center>
                      <Link
                        href="https://dmtp.gitbook.io/dmtp-docs/about-dmtp/chat-sticker-nft"
                        isExternal>
                        <Button
                          rounded={'full'}
                          _hover={{ boxShadow: 'none', opacity: 0.75 }}
                          bg={bgButton}
                          color={colorButton}
                          fontSize="sm"
                          borderRadius="14px"
                          px="30px"
                          display={'flex'}>
                          {$t('home:learn_more')}
                        </Button>
                      </Link>
                    </Center>
                  </Stack>
                </Stack>
              </Center>
            </Stack> */}
            <Stack minH={'10vh'} direction={{ base: 'column', md: 'row' }} p={'auto'}>
              <Center flex={1}>
                {isSmallScreen ? (
                  <Image
                    alt={'Login Image'}
                    objectFit={'cover'}
                    src={'images/chat-key-market.png'}
                    width="240px"
                    height={'240px'}
                  />
                ) : (
                  <Center>
                    <Image
                      alt={'Login Image'}
                      objectFit={'cover'}
                      src={'images/chat-key-market.png'}
                      width={{ base: '282px', md: '230px', lg: '334px' }}
                      height={{ base: '282px', md: '230px', lg: '334px' }}
                    />
                  </Center>
                )}
              </Center>
              <Center p={{ base: 2, md: 8 }} flex={1}>
                <Stack spacing={6} w={'full'} maxW={'lg'}>
                  <Heading
                    fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}
                    textAlign={{ base: 'center', md: 'left' }}>
                    <Text
                      as={'span'}
                      position={'relative'}
                      textAlign={{ base: 'center', md: 'left' }}
                      className={`${textColor}`}>
                      <Trans
                        i18nKey={'home:chat_key_title'}
                        components={{
                          highlight: (
                            <Text
                              position={'relative'}
                              textAlign={{ base: 'center', md: 'left' }}
                              color={'#7E4698'}
                              as={'span'}
                            />
                          ),
                        }}
                      />
                    </Text>
                  </Heading>
                  <Text
                    fontSize={{ base: 'md', lg: 'lg' }}
                    color={'gray.500'}
                    textAlign={{ base: 'center', md: 'left' }}>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: $t('home:chat_key_description'),
                      }}></span>
                  </Text>
                  {[1, 2, 3].map(i => {
                    return (
                      <div key={i}>
                        <Text
                          fontSize={{ base: 'md', lg: 'lg' }}
                          fontWeight={'600'}
                          className={`${textColor}`}
                          textAlign={{ base: 'center', md: 'left' }}>
                          {$t(`home:chat_key_sub_${i}`)}
                        </Text>
                        <Text
                          fontSize={{ base: 'md', lg: 'lg' }}
                          color={'gray.500'}
                          mt={['4px !important']}
                          textAlign={{ base: 'center', md: 'left' }}>
                          <span
                            dangerouslySetInnerHTML={{
                              __html: $t(`home:chat_key_des_${i}`),
                            }}></span>
                        </Text>
                      </div>
                    );
                  })}
                </Stack>
              </Center>
            </Stack>
          </Box>
        </Flex>
      </div>
      <div className="section-gradient section-common">
        <Stack as={Box} textAlign={'center'} spacing={{ base: 0, md: 0 }} p={15}>
          <Heading
            fontWeight={600}
            fontSize={{ base: '5xl', md: '6xl', xl: '7xl' }}
            lineHeight={'110%'}
            p={10}>
            {$t('home:technical')}
          </Heading>
        </Stack>
        <Box p={6}>
          <SimpleGrid
            columns={{ base: 1, lg: 2, xl: 4 }}
            spacing={10}
            p={'auto'}
            justifyContent="center"
            alignItems={'center'}
            pb={20}>
            <Center>
              <Box
                maxW={{ base: '400px', sm: '500px', xl: '324px' }}
                w={'full'}
                // bg={useColorModeValue('white', 'gray.900')}
                boxShadow={'2xl'}
                rounded={'lg'}
                p={6}
                textAlign={'center'}
                className={`${bg}`}
                color={colorMode === 'dark' ? 'white' : 'black'}>
                <Avatar size={'xl'} src={'images/security.svg'} mb={4} pos={'relative'} />
                <Heading
                  fontSize={'2xl'}
                  fontFamily={'body'}
                  // color={useColorModeValue('gray.900', 'white')}
                >
                  {$t('home:end_to_end')}

                  <br />
                  <br />
                </Heading>
                <Text
                  textAlign={'center'}
                  // color={useColorModeValue('gray.700', 'gray.400')}
                  px={3}>
                  {$t('home:end_to_end_description')}
                </Text>
                <Stack
                  mt={8}
                  direction={'row'}
                  spacing={4}
                  textAlign={'center'}
                  justifyContent="center">
                  <Link
                    href={'https://dmtp.gitbook.io/dmtp-docs/dmtp-system/encryption-and-decryption'}
                    color={'blue.400'}
                    isExternal>
                    {$t('home:see_more')}
                  </Link>
                </Stack>
              </Box>
            </Center>
            <Center>
              <Box
                maxW={{ base: '400px', sm: '500px', xl: '324px' }}
                w={'full'}
                // bg={useColorModeValue('white', 'gray.900')}
                boxShadow={'2xl'}
                rounded={'lg'}
                p={6}
                textAlign={'center'}
                className={`${bg}`}
                color={colorMode === 'dark' ? 'white' : 'black'}>
                <Avatar size={'xl'} src={'images/decentralized.svg'} mb={4} pos={'relative'} />
                <Heading
                  fontSize={'2xl'}
                  fontFamily={'body'}
                  // color={useColorModeValue('gray.900', 'white')}
                >
                  {$t('home:decent_perman')}
                  <br />
                  <br />
                </Heading>
                <Text
                  textAlign={'center'}
                  // color={useColorModeValue('gray.700', 'gray.400')}
                  px={3}>
                  {$t('home:decent_perman_description')}
                </Text>

                <Stack
                  mt={8}
                  direction={'row'}
                  spacing={4}
                  textAlign={'center'}
                  justifyContent="center">
                  <Link
                    href={'https://dmtp.gitbook.io/dmtp-docs/dmtp-system/message-data-storage'}
                    color={'blue.400'}
                    isExternal>
                    {$t('home:see_more')}
                  </Link>
                </Stack>
              </Box>
            </Center>
            <Center>
              <Box
                maxW={{ base: '400px', sm: '500px', xl: '324px' }}
                w={'full'}
                // bg={useColorModeValue('white', 'gray.900')}
                boxShadow={'2xl'}
                rounded={'lg'}
                p={6}
                textAlign={'center'}
                className={`${bg}`}
                color={colorMode === 'dark' ? 'white' : 'black'}>
                <Avatar size={'xl'} src={'images/customer.svg'} mb={4} pos={'relative'} />
                <Heading
                  fontSize={'2xl'}
                  fontFamily={'body'}
                  // color={useColorModeValue('gray.900', 'white')}
                >
                  <br />
                  {$t('home:multi_clients')}
                  <br />
                  <br />
                </Heading>
                <Text
                  textAlign={'center'}
                  // color={useColorModeValue('gray.700', 'gray.400')}
                  px={3}>
                  {$t('home:multi_clients_description')}
                </Text>

                <Stack
                  mt={8}
                  direction={'row'}
                  spacing={4}
                  textAlign={'center'}
                  justifyContent="center">
                  <Link
                    href={'https://dmtp.gitbook.io/dmtp-docs/dmtp-system/multi-client'}
                    color={'blue.400'}
                    isExternal>
                    {$t('home:see_more')}
                  </Link>
                </Stack>
              </Box>
            </Center>
            <Center>
              <Box
                maxW={{ base: '400px', sm: '500px', xl: '324px' }}
                w={'full'}
                // bg={useColorModeValue('white', 'gray.900')}
                boxShadow={'2xl'}
                rounded={'lg'}
                p={6}
                textAlign={'center'}
                className={`${colorMode === 'dark' ? 'bg-antd' : 'bg-white'}`}
                color={colorMode === 'dark' ? 'white' : 'black'}>
                <Avatar size={'xl'} src={'images/sdk.svg'} mb={4} pos={'relative'} />
                <Heading
                  fontSize={'2xl'}
                  fontFamily={'body'}
                  // color={useColorModeValue('gray.900', 'white')}
                >
                  <br />
                  {$t('home:sdk')}
                  <br />
                  <br />
                </Heading>
                <Text
                  textAlign={'center'}
                  // color={useColorModeValue('gray.700', 'gray.400')}
                  px={3}>
                  {$t('home:sdk_description')}
                </Text>

                <Stack
                  mt={8}
                  direction={'row'}
                  spacing={4}
                  textAlign={'center'}
                  justifyContent="center">
                  <Link
                    href={'https://dmtp.gitbook.io/dmtp-docs/builders-guides/dmtp-sdk'}
                    color={'blue.400'}
                    isExternal>
                    {$t('home:see_more')}
                  </Link>
                </Stack>
              </Box>
            </Center>
          </SimpleGrid>
        </Box>
      </div>
      <Flex
        justifyContent={'center'}
        alignItems={'center'}
        // bg={useColorModeValue('white', 'gray.900')}
      >
        <Box w={'90%'}>
          <Stack as={Box} textAlign={'center'} spacing={{ base: 0, md: 0 }} py={{ base: 0, md: 0 }}>
            <Heading
              pt={20}
              fontWeight={'bold'}
              fontSize={{ base: '3xl', sm: '4xl', md: '5xl' }}
              lineHeight={'110%'}
              className={`${textColor}`}>
              {$t('home:investors')}
            </Heading>
          </Stack>
          <SimpleGrid
            columns={{ base: 1, md: 3 }}
            spacing={10}
            justifyContent="center"
            alignItems={'center'}>
            <Center>
              <Link href="https://east.vc/" isExternal>
                <Image alt={'East Ventures'} objectFit={'cover'} src={'images/ev.png'} />
              </Link>
            </Center>
            <Center>
              <Link href="https://arriba.studio/en/" isExternal>
                <Image alt={'Arriba Studio'} objectFit={'cover'} src={'images/arriba.jpg'} />
              </Link>
            </Center>
            <Center>
              <Link href="https://www.hd.square-enix.com/eng/" isExternal>
                <Image alt={'SQUARE ENIX'} objectFit={'cover'} src={'images/Square_Enix.png'} />
              </Link>
            </Center>
            <Center>
              <Link href="https://www.doublejump.tokyo/en" isExternal>
                <Image
                  alt={'doublejump.tokyo'}
                  objectFit={'cover'}
                  src={'images/djt.webp'}
                  height={'100px'}
                />
              </Link>
            </Center>
            <Center>
              <Link href="https://adways-ventures.net/en/" isExternal>
                <Image
                  alt={'adways_ventures'}
                  objectFit={'cover'}
                  src={'images/Adways_Ventures.png'}
                  height={'100px'}
                />
              </Link>
            </Center>
            <Center>
              <Link href="https://capital-dao.xyz/" isExternal>
                <Image alt={'Capital DAO'} objectFit={'cover'} src={'images/Capital_DAO.png'} />
              </Link>
            </Center>
          </SimpleGrid>
          <Divider p={'auto'} />
          <Stack as={Box} textAlign={'center'} spacing={{ base: 0, md: 0 }} py={{ base: 0, md: 0 }}>
            <Heading
              pt={20}
              fontWeight={'bold'}
              fontSize={{ base: '3xl', sm: '4xl', md: '5xl' }}
              lineHeight={'110%'}
              className={`${textColor}`}>
              {$t('home:partnerships')}
            </Heading>
          </Stack>
          <SimpleGrid columns={{ base: 2, md: 4 }} spacing={3} mt={0} mb={10}>
            <Center mt={10}>
              <Link href="https://chain.link/" isExternal>
                <Image
                  alt={'Chainlink'}
                  objectFit={'cover'}
                  src={'images/Chainlink.png'}
                  width={{ base: '300px', md: '150px', lg: '200px', xl: '250px' }}
                />
              </Link>
            </Center>
            <Center mt={10}>
              <Link href="https://www.kcc.io/" isExternal>
                <Image
                  alt={'KCC'}
                  objectFit={'cover'}
                  src={'images/kcc.svg'}
                  width={{ base: '300px', md: '150px', lg: '200px', xl: '250px' }}
                />
              </Link>
            </Center>
            <Center mt={10}>
              <Link href="https://unstoppabledomains.com/" isExternal>
                <Image
                  width={{ base: '300px', md: '150px', lg: '200px', xl: '250px' }}
                  alt={'Unstoppable Domains'}
                  objectFit={'cover'}
                  src={'images/unstoppable.png'}
                />
              </Link>
            </Center>
            <Center mt={10}>
              <Link href="https://nttdigital.io/en#top" isExternal>
                <Image
                  alt={'NTT Digital'}
                  objectFit={'cover'}
                  src={'images/NTT_Digital.png'}
                  width={{ base: '300px', md: '150px', lg: '200px', xl: '250px' }}
                />
              </Link>
            </Center>
            <Center mt={10}>
              <Link href="https://space.id/" isExternal>
                <Image
                  alt={'Space ID'}
                  objectFit={'cover'}
                  src={'images/space_id.svg'}
                  width={{ base: '300px', md: '150px', lg: '200px', xl: '250px' }}
                />
              </Link>
            </Center>
            <Center mt={10}>
              <Link href="https://port3.io/" isExternal>
                <Image
                  alt={'Port3'}
                  objectFit={'cover'}
                  src={'images/port3.svg'}
                  width={{ base: '300px', md: '150px', lg: '200px', xl: '250px' }}
                />
              </Link>
            </Center>
            <Center mt={10}>
              <Link href="https://jpyc.jp/" isExternal>
                <Image
                  alt={'JPYC'}
                  objectFit={'cover'}
                  src={'images/jpyc.svg'}
                  width={{ base: '300px', md: '150px', lg: '200px', xl: '250px' }}
                />
              </Link>
            </Center>
            <Center mt={10}>
              <Link href="https://uni-corn.net/en/index.html" isExternal>
                <Image
                  alt={'Unicorn'}
                  objectFit={'cover'}
                  src={'images/unicorn.png'}
                  width={{ base: '300px', md: '150px', lg: '200px', xl: '250px' }}
                />
              </Link>
            </Center>
            <Center mt={10}>
              <Link href="https://www.mycryptoheroes.net/" isExternal>
                <Image
                  alt={'My Crypto Heroes'}
                  objectFit={'cover'}
                  src={'images/mch.png'}
                  width={{ base: '300px', md: '150px', lg: '200px', xl: '250px' }}
                />
              </Link>
            </Center>
            <Center mt={10}>
              <Link href="https://www.mycryptoheroes.net/verse" isExternal>
                <Image
                  alt={'MCH Verse'}
                  objectFit={'cover'}
                  src={'images/mchverse.png'}
                  width={{ base: '300px', md: '150px', lg: '200px', xl: '250px' }}
                />
              </Link>
            </Center>

            <Center mt={10}>
              <Link href="https://www.homeverse.games/" isExternal>
                <Image
                  alt={'HOME Verse'}
                  objectFit={'cover'}
                  src={'images/hmv.png'}
                  width={{ base: '300px', md: '150px', lg: '200px', xl: '250px' }}
                />
              </Link>
            </Center>
            <Center mt={10}>
              <Link href="https://tcgverse.xyz/" isExternal>
                <Image
                  alt={'TCG Verse'}
                  objectFit={'cover'}
                  src={'images/tcg.png'}
                  width={{ base: '300px', md: '150px', lg: '200px', xl: '250px' }}
                />
              </Link>
            </Center>
            <Center mt={10}>
              <Link href="https://avvy.domains/" isExternal>
                <Image
                  alt={'Avvy Domains'}
                  objectFit={'cover'}
                  src={'images/avvy.svg'}
                  width={{ base: '300px', md: '150px', lg: '200px', xl: '250px' }}
                />
              </Link>
            </Center>
            <Center mt={10}>
              <Link href="https://sakaba.xyz/" isExternal>
                <Image
                  alt={'SAKABA'}
                  objectFit={'cover'}
                  src={'images/sakaba.png'}
                  width={{ base: '300px', md: '150px', lg: '200px', xl: '250px' }}
                />
              </Link>
            </Center>
            <Center mt={10}>
              <Link href="https://intellax.io/" isExternal>
                <Image
                  alt={'Intella X'}
                  objectFit={'cover'}
                  src={'images/intellax.png'}
                  width={{ base: '300px', md: '150px', lg: '200px', xl: '250px' }}
                />
              </Link>
            </Center>
            <Center mt={10}>
              <Link href="https://cryptogames.co.jp/" isExternal>
                <Image
                  alt={'Crypto Games'}
                  objectFit={'cover'}
                  src={'images/crypto_games.png'}
                  width={{ base: '300px', md: '150px', lg: '200px', xl: '250px' }}
                />
              </Link>
            </Center>
            <Center mt={10}>
              <Link href="https://www.kapital.gg/" isExternal>
                <Image
                  alt={'Kapital DAO'}
                  objectFit={'cover'}
                  src={'images/kapital_dao.png'}
                  width={{ base: '312px', md: '150px', lg: '200px', xl: '250px' }}
                />
              </Link>
            </Center>
          </SimpleGrid>
          <Divider p={'auto'} />
          <Stack as={Box} textAlign={'center'} spacing={{ base: 0, md: 0 }} py={{ base: 0, md: 0 }}>
            <Heading
              pt={20}
              fontWeight={'bold'}
              fontSize={{ base: '3xl', sm: '4xl', md: '5xl' }}
              lineHeight={'110%'}
              className={`${textColor}`}>
              {$t('home:supporters')}
            </Heading>
          </Stack>
          <Center>
            <SimpleGrid
              mt={10}
              columns={{ base: 3, sm: 4, md: 6, lg: 8 }}
              spacing={10}
              alignItems="center"
              justifyContent={'center'}>
              <Link href="https://twitter.com/alphabirds_xyz" isExternal>
                <Avatar size={'xl'} src={'images/alpha_birds.png'} mb={4} pos={'relative'} />
              </Link>
              <Link href="https://twitter.com/veefriends" isExternal>
                <Avatar size={'xl'} src={'images/vee_friends.png'} mb={4} pos={'relative'} />
              </Link>
              <Link href="https://twitter.com/KarafuruNFT" isExternal>
                <Avatar size={'xl'} src={'images/karafuru.jpg'} mb={4} pos={'relative'} />
              </Link>
              <Link href="https://twitter.com/bb_jpdao" isExternal>
                <Avatar size={'xl'} src={'images/bb.png'} mb={4} pos={'relative'} />
              </Link>
              <Link href="https://twitter.com/GuildQB" isExternal>
                <Avatar size={'xl'} src={'images/GuildQB.png'} mb={4} pos={'relative'} />
              </Link>
              <Link href="https://twitter.com/SpaceRunnersNFT" isExternal>
                <Avatar size={'xl'} src={'images/space_runners.png'} mb={4} pos={'relative'} />
              </Link>
              <Link href="https://twitter.com/ChimpersNFT" isExternal>
                <Avatar size={'xl'} src={'images/chimpers.jpg'} mb={4} pos={'relative'} />
              </Link>
              <Link href="https://twitter.com/coolmanuniverse" isExternal>
                <Avatar size={'xl'} src={'images/coolman.jpg'} mb={4} pos={'relative'} />
              </Link>
              <Link href="https://twitter.com/Alphazillanft" isExternal>
                <Avatar size={'xl'} src={'images/alphazilla.png'} mb={4} pos={'relative'} />
              </Link>
              <Link href="https://twitter.com/PlanetDegenNFT" isExternal>
                <Avatar size={'xl'} src={'images/planet_degen.jpg'} mb={4} pos={'relative'} />
              </Link>
              <Link href="https://twitter.com/WarriorsOfAnkh" isExternal>
                <Avatar size={'xl'} src={'images/warrior_of_ankh.jpg'} mb={4} pos={'relative'} />
              </Link>
              <Link href="https://twitter.com/Mintify" isExternal>
                <Avatar size={'xl'} src={'images/mintify.png'} mb={4} pos={'relative'} />
              </Link>
              <Link href="https://twitter.com/DarkEchelonn" isExternal>
                <Avatar size={'xl'} src={'images/dark_echelonn.png'} mb={4} pos={'relative'} />
              </Link>
              <Link href="https://twitter.com/limelight_kor" isExternal>
                <Avatar size={'xl'} src={'images/lime_light.jpg'} mb={4} pos={'relative'} />
              </Link>
              <Link href="https://twitter.com/AstarDegens" isExternal>
                <Avatar size={'xl'} src={'images/Astar_Digens.png'} mb={4} pos={'relative'} />
              </Link>
              <Link href="https://twitter.com/DAO_ODEN" isExternal>
                <Avatar size={'xl'} src={'images/oden_dao.jpeg'} mb={4} pos={'relative'} />
              </Link>
              <Link href="https://twitter.com/BunzzDev" isExternal>
                <Avatar size={'xl'} src={'images/bunzz.jpeg'} mb={4} pos={'relative'} />
              </Link>
            </SimpleGrid>
          </Center>
        </Box>
      </Flex>
      <div className={'section-common'}>
        <Stack as={Box} textAlign={'center'} spacing={{ base: 0, md: 0 }} p={'auto'}>
          <Heading
            pt={20}
            fontWeight={'bold'}
            fontSize={{ base: '3xl', sm: '4xl', md: '5xl' }}
            lineHeight={'110%'}
            className={`${textColor}`}>
            {$t('home:team')}
          </Heading>
        </Stack>
        <Box p={4}>
          <SimpleGrid columns={{ base: 1, lg: 2 }} p={'auto'}>
            <Center p={6}>
              <Box
                maxW={'400px'}
                w={'full'}
                // bg={useColorModeValue('white', 'gray.900')}
                boxShadow={'2xl'}
                rounded={'lg'}
                p={6}
                textAlign={'center'}
                className={`${bg}`}
                color={colorMode === 'dark' ? 'white' : 'black'}>
                <Avatar size={'xl'} src={'images/aru.jpeg'} mb={4} pos={'relative'} />
                <Heading
                  fontSize={'2xl'}
                  fontFamily={'body'}
                  // color={useColorModeValue('gray.900', 'white')}
                >
                  Aru Sasaki
                </Heading>
                <Text fontWeight={600} color={'gray.500'} mb={4}>
                  co-founder CEO
                </Text>
                {/* <Text>
                  Interned at a crypto VC while studying in New York. While conducting due
                  diligence, investment ratios, and research for portfolio projects, he also
                  supported managing a blog dedicated to blockchain. After returning to Japan, he
                  interned at Hokusai, an NFT infrastructure development company, as a member of the
                  board of directors and in public relations, and launched DMTP.
                </Text> */}

                <Stack mt={8} direction={'row'} spacing={4}>
                  <Link href="https://t.me/AruSasaki" isExternal flex={1}>
                    <Button
                      colorScheme="telegram"
                      leftIcon={<FaTelegram />}
                      size={{ base: 'md', lg: 'sm', xl: 'md' }}>
                      Telegram
                    </Button>
                  </Link>
                  <Link href="https://twitter.com/Aru_Web3en" isExternal flex={1}>
                    <Button
                      colorScheme="twitter"
                      leftIcon={<FaTwitter />}
                      size={{ base: 'md', lg: 'sm', xl: 'md' }}>
                      Twitter
                    </Button>
                  </Link>
                </Stack>
              </Box>
            </Center>
            <Center p={6}>
              <Box
                maxW={'400px'}
                w={'full'}
                boxShadow={'2xl'}
                rounded={'lg'}
                p={6}
                textAlign={'center'}
                className={`${bg}`}
                color={colorMode === 'dark' ? 'white' : 'black'}>
                <Avatar size={'xl'} src={'images/kosuke.jpeg'} mb={4} pos={'relative'} />
                <Heading
                  fontSize={'2xl'}
                  fontFamily={'body'}
                  // color={useColorModeValue('gray.900', 'white')}
                >
                  Kosuke Araki
                </Heading>
                <Text fontWeight={600} color={'gray.500'} mb={4}>
                  co-founder COO
                </Text>
                {/* <Text>
                  Continuous entrepreneur. Started many companies, including BigData, Adtech, and
                  D2C. He started "SecondLife" of Metaverse consulting for major companies at
                  Meltingdots. In 2015 he co-founded a project with CZ (Binance) to launch a
                  cryptocurrency exchange in Japan. In 2022, he found DMTP with Aru.
                </Text> */}

                <Stack mt={8} direction={'row'} spacing={4} p={'auto'}>
                  <Center flex={1}>
                    <Link href="https://t.me/kosuke_araki" isExternal>
                      <Button
                        colorScheme="telegram"
                        leftIcon={<FaTelegram />}
                        size={{ base: 'md', lg: 'sm', xl: 'md' }}>
                        Telegram
                      </Button>
                    </Link>
                  </Center>
                  <Center flex={1}>
                    <Link href="https://twitter.com/kosuke_araki" isExternal>
                      <Button
                        colorScheme="twitter"
                        leftIcon={<FaTwitter />}
                        size={{ base: 'md', lg: 'sm', xl: 'md' }}>
                        Twitter
                      </Button>
                    </Link>
                  </Center>
                </Stack>
              </Box>
            </Center>
          </SimpleGrid>
        </Box>
      </div>

      <div className="section-gradient section-common">
        <Box color={useColorModeValue('gray.700', 'gray.200')}>
          <Container as={Stack} maxW={'6xl'} py={10}>
            <div className="footer-container">
              <SimpleGrid templateColumns={{ sm: '1fr 1fr', md: '2fr 1fr 1fr 2fr' }} spacing={8}>
                <Stack direction={'row'} spacing={6}>
                  <SocialButton label={'Twitter'} href={'https://twitter.com/DMTPHQ'}>
                    <FaTwitter />
                  </SocialButton>
                  <SocialButton label={'Discord'} href={DISCORD_LINK}>
                    <FaDiscord />
                  </SocialButton>
                  <SocialButton label={'Github'} href={'https://github.com/DMTP-Protocol'}>
                    <FaGithub />
                  </SocialButton>
                </Stack>
              </SimpleGrid>
              <div className="term-section">
                <Link
                  color={'blue.400'}
                  colorScheme={'blue'}
                  isExternal
                  rel="noopener,noreferrer"
                  href={ROUTES.tos}>
                  {$t('home:termsOfUse')}
                </Link>
                <Link
                  color={'blue.400'}
                  colorScheme={'blue'}
                  isExternal
                  rel="noopener,noreferrer"
                  href={ROUTES.privacyPolicies}>
                  {$t('home:PrivacyPolicy')}
                </Link>
              </div>
            </div>
          </Container>
        </Box>
      </div>
    </Styled.Container>
  );
};

export default Home;
